// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import ProductBlockVertical from '/react4xp/components/ProductBlockVertical'

// prop types
interface NewProductsBannerProps {

    // product banner props
    sectionTitle?: string
    howMany?: 1 | 2 | 3

    // product card props
    products?: Array<{
        href: string
        external?: boolean
        src: string
        srcMobile: string
        alt?: string
        title: string
        desc: string
    }>
}

export default function NewProductsBanner({
    sectionTitle,
    howMany,
    products
}: NewProductsBannerProps) {
    return (
        <Section className='new-products-banner'>
            <div className='container'>

                {sectionTitle && (
                    <h2 className='section-title h1-hero-big'>
                        {sectionTitle}
                    </h2>
                )}

                <div className='row'>
                    {products && products.length > 0 && (
                        products && products.map((item, i) => (
                            <div className='col-md-6 col-xl-4' key={i}>
                                <ProductBlockVertical
                                    blockSize='small'
                                    href={item.href}
                                    external={item.external}
                                    src={item.src}
                                    srcMobile={item.srcMobile}
                                    alt={item.alt}
                                    width={300}
                                    sizes='(max-width: 480px) 100vw, (max-width: 768px) 50vw, 300px'
                                    title={item.title}
                                    desc={item.desc}
                                />
                            </div>
                        ))
                    )}
                </div>

            </div>
        </Section>
    )
}